export const black = '#000000';
export const white = '#ffffff';
export const slate = '#d7d7d7';
export const granite = '#232323';
export const gray = '#222'
